/* eslint-disable react-hooks/exhaustive-deps */


import {useEffect} from "react";
import {useNavigate} from 'react-router-dom';
import {verifiedAccessToken} from "../../utils/Utils";

const PublicLayout = ({children}) => {
    const navigate = useNavigate();
    // useEffect(() => {
    //     if (verifiedAccessToken()) {
    //         navigate('/', {replace: true});
    //     }
    // }, []);
    return children;
};

export default PublicLayout;
